import { observer } from 'mobx-react-lite';
import React, {
  FC, useEffect, useState,
} from 'react';
import '../../styles/views/onboardingPage/onboardingPage.scss';
import { useNavigate, useParams } from 'react-router-dom';
import {
  IOnboardingData, OnboardingData,
} from '@utils';
import { OnboardingCalendarHelper, OnboardingHelper } from '../../components/onboarding';

export const OnboardingPage: FC = observer(() => {
  const navigate = useNavigate();
  const { calendarUrl } = useParams();
  const [onboardingData, setOnboardingData] = useState<IOnboardingData | null>(calendarUrl ? OnboardingData.find((data) => data.url === calendarUrl) : null);
  const [imageIndex, setImageIndex] = useState(0);

  useEffect(() => {
    if (calendarUrl && !OnboardingData.find((data) => data.url === calendarUrl)) {
      navigate('/onboarding');
    } else if (onboardingData && onboardingData.url !== calendarUrl) {
      setOnboardingData(OnboardingData.find((data) => data.url === calendarUrl));
      setImageIndex(0);
    }
  }, [calendarUrl]);

  return (
    <>
      {onboardingData ? (
        <OnboardingCalendarHelper onboardingData={onboardingData} imageIndex={imageIndex} setImageIndex={setImageIndex} showSogoButton={calendarUrl === 'thunderbird'} />
      ) : (
        <OnboardingHelper />
      )}
    </>
  );
});
